import { API } from '../config/axiosConfig';

export const cardsAPI = {
  //   // Create new card listing
  //   createCardListing: async (listingData) => {
  //     try {
  //       const response = await API.post("/cards/create-card-listing/", listingData, {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //         },
  //       })
  //       return response.data
  //     } catch (error) {
  //       throw error
  //     }
  //   },

  //   // Get user's card listings
  //   getUserListings: async () => {
  //     try {
  //       const response = await API.get("/cards/user-listings/")
  //       return response.data
  //     } catch (error) {
  //       throw error
  //     }
  //   },

  //   // Update card listing
  //   updateCardListing: async (listingId, listingData) => {
  //     try {
  //       const response = await API.put(`/cards/update-listing/${listingId}/`, listingData, {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //         },
  //       })
  //       return response.data
  //     } catch (error) {
  //       throw error
  //     }
  //   },

  //   // Delete card listing
  //   deleteCardListing: async (listingId) => {
  //     try {
  //       const response = await API.delete(`/cards/delete-listing/${listingId}/`)
  //       return response.data
  //     } catch (error) {
  //       throw error
  //     }
  //   },

  // Get all available cards for selection (paginated; response carries
  // page/page_size/has_more for future infinite scroll)
  getAvailableCards: async (card_name, { page = 1, pageSize = 30 } = {}) => {
    try {
      const params = new URLSearchParams({
        card_name,
        page: String(page),
        page_size: String(pageSize),
      });
      const response = await API.get(`api/cards/search-card/?${params.toString()}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getLookUPCard: async (card_id) => {
    try {
      const response = await API.get(`api/cards/fetch-card-lookup/?card_id=${card_id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getListingSuggestedPrice: async ({ productId, finish, condition }) => {
    try {
      const params = new URLSearchParams({ product_id: productId });
      if (finish) params.append('finish', finish);
      if (condition) params.append('condition', condition);
      const response = await API.get(`api/cards/listing-suggested-price/?${params.toString()}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getLookUPCardDetails: async (card_id) => {
    try {
      const url = `api/cards/fetch-card-lookup-detail/?card_id=${card_id}`;

      console.log('Fetching:', url);

      const response = await API.get(url);
      return response.data;
    } catch (error) {
      console.error('Error in getLookUPCardDetails:', error.message);
      throw error;
    }
  },

  // The slow, deliberately-abandonable half of the card page: the upstream
  // price fetch and the repricing it drives. `getLookUPCardDetails` /
  // `getListDetailsPaginated` above hit `fetch-card-lookup-detail/`, now a
  // pure DB read; this hits a DIFFERENT endpoint that does the expensive
  // work. See CardDetail.jsx for the fire-after-paint, swallow-your-own-
  // errors caller.
  refreshCardPrices: async (card_id) => {
    try {
      const response = await API.get(`api/cards/refresh-card-prices/?card_id=${card_id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getListDetails: async (listId) => {
    try {
      const response = await API.get(`api/cards/card-listing-detail/${listId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getListingsByIds: async (ids = []) => {
    const clean = (ids || []).filter((id) => id != null);
    if (clean.length === 0) {
      return { success: true, listings: [] };
    }
    const response = await API.get(`api/cards/listings-by-ids/?ids=${clean.join(',')}`);
    return response.data;
  },

  addToCart: async (payload) => {
    try {
      const response = await API.post(`api/orders/add-to-cart/`, payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getLookUpCards: async (filters) => {
    try {
      // Create a copy of filters to avoid modifying the original
      const modifiedFilters = { ...filters };

      // Convert arrays to the required format
      if (modifiedFilters.rarity && Array.isArray(modifiedFilters.rarity)) {
        modifiedFilters.rarity = JSON.stringify(modifiedFilters.rarity);
      }

      if (modifiedFilters.condition && Array.isArray(modifiedFilters.condition)) {
        modifiedFilters.condition = JSON.stringify(modifiedFilters.condition);
      }

      const validParams = {
        category: (val) => val && val !== 'All',
        condition: (val) => !!val,
        rarity: (val) => !!val,
        min_price: (val) => typeof val === 'number' && val > 0,
        max_price: (val) => typeof val === 'number' && val < 1000,
        search: (val) => val && val.trim() !== '',
        sort: (val) => val && val.trim() !== null,
        page: (val) => typeof val === 'number' && val >= 1,
        page_size: (val) => typeof val === 'number' && val > 0,
        available_to_buy: (val) => val,
        set: (val) => val && val.trim() !== '',
        catalog_group_id: (val) => val && val.trim() !== '',
        tcg_category_id: (val) => val && val.trim() !== '',
        card: (val) => val === true,
        sealed: (val) => val === true,
      };

      const queryParams = new URLSearchParams();
      Object.entries(modifiedFilters).forEach(([key, value]) => {
        if (validParams[key]?.(value)) {
          queryParams.append(key, value);
        }
      });

      const response = await API.get(`api/cards/card-lookup/?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getListDetailsPaginated: async (cardId, page, pageSize) => {
    try {
      const cleanCardId = (cardId || '').toString().trim();
      if (!cleanCardId) throw new Error('Invalid cardId');

      const url = `api/cards/fetch-card-lookup-detail/?page_size=${pageSize}&page=${page}&card_id=${cleanCardId}`;

      const response = await API.get(url);
      return response.data;
    } catch (error) {
      console.error('Error in getListDetailsPaginated:', error.message);
      throw error;
    }
  },

  getSellerCards: async (filters) => {
    try {
      // Create a copy of filters to avoid modifying the original
      const modifiedFilters = { ...filters };

      // Convert arrays to the required format (same as getLookUpCards)
      if (modifiedFilters.rarity && Array.isArray(modifiedFilters.rarity)) {
        modifiedFilters.rarity = JSON.stringify(modifiedFilters.rarity);
      }

      if (modifiedFilters.condition && Array.isArray(modifiedFilters.condition)) {
        modifiedFilters.condition = JSON.stringify(modifiedFilters.condition);
      }

      const queryParams = new URLSearchParams();

      const validParams = {
        seller_id: (val) => val && val !== null,
        sort: (val) => val && val.trim() !== null,
        index: (val) => typeof val === 'number' && val >= 0,
        offset: (val) => typeof val === 'number' && val >= 0,
        search: (val) => val && val.trim() !== '',
        card: (val) => val === true,
        sealed: (val) => val === true,
        category: (val) => val && val !== 'All',
        condition: (val) => !!val,
        rarity: (val) => !!val,
        min_price: (val) => typeof val === 'number' && val > 0,
        max_price: (val) => typeof val === 'number' && val < 1000,
        available_to_buy: (val) => val,
        set: (val) => val && val.trim() !== '',
        catalog_group_id: (val) => val && val.trim() !== '',
        tcg_category_id: (val) => val && val.trim() !== '',
      };

      Object.entries(modifiedFilters).forEach(([key, value]) => {
        if (validParams[key]?.(value)) {
          queryParams.append(key, value);
        }
      });

      const response = await API.get(`api/cards/seller-card-lookup/?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
